/**
 * Logo ProMeet Missions — combinaison volant + éclair (urgence/réactivité),
 * dans la palette teal de la plateforme.
 */
export default function MissionsLogo({ size = 38, withText = false }) {
  const id = `pmm-grad-${size}`;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        lineHeight: 1,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#14b8a6" />
            <stop offset="0.55" stopColor="#0f766e" />
            <stop offset="1" stopColor="#0c4a6e" />
          </linearGradient>
        </defs>

        {/* Disque principal */}
        <rect x="2" y="2" width="60" height="60" rx="16" fill={`url(#${id})`} />

        {/* Reflet doux */}
        <path
          d="M2 18C12 4 32 0 50 6"
          stroke="white"
          strokeOpacity="0.18"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />

        {/* Volant stylisé */}
        <circle cx="32" cy="32" r="14" stroke="white" strokeWidth="2.4" />
        <circle cx="32" cy="32" r="3.4" fill="white" />
        <path
          d="M32 21v6.5M21 32h6.5M43 32h-6.5M32 43v-6.5"
          stroke="white"
          strokeWidth="2.4"
          strokeLinecap="round"
        />

        {/* Éclair urgence (bas-droite) */}
        <path
          d="M46.5 41.5l-7 9 2.5-5.5h-3.5l5.5-8 -1 4.5h3.5z"
          fill="#fde047"
          stroke="#0f172a"
          strokeOpacity="0.25"
          strokeWidth="0.6"
        />
      </svg>

      {withText && (
        <span
          style={{
            display: "inline-flex",
            flexDirection: "column",
            lineHeight: 1.05,
            fontWeight: 800,
            letterSpacing: "-0.01em",
          }}
        >
          <span style={{ color: "var(--espresso)", fontSize: 16 }}>
            ProMeet <span style={{ color: "var(--color-primary-hover)" }}>Missions</span>
          </span>
          <span style={{ color: "var(--text-muted)", fontSize: 11, fontWeight: 600, marginTop: 2 }}>
            Marketplace automobile B2B
          </span>
        </span>
      )}
    </span>
  );
}
